module.exports = __webpack_public_path__ + "components/flag/static/square/vu-95eb7514025c889745d7ceb9d663fec3.svg";